import ProxyBase from '../../../../core/proxies/ProxyBase'

class UserManagementProxy extends ProxyBase {
  getUserProfile(params) {
    return this.get('UserProfile', params)
  }

  postUpdateUserProfileRequest(params) {
    return this.post('UpdateUserProfileRequest', params)
  }

  putUserProfile(params) {
    return this.put('UserProfile', params)
  }

  getUserSetting(params) {
    return this.get('UserSetting', params)
  }

  putUserSetting(params) {
    return this.put('UserSetting', params)
  }

  getUserSettingWithPreference(params) {
    return this.get('UserSettingWithPreference', params)
  }

  getSubscriptionPlans(params) {
    return this.get('SubscriptionPlans', params)
  }

  getSubscriptionPlanDetails(params) {
    return this.get('SubscriptionPlanDetails', params)
  }

  getPricingPackages(params) {
    return this.get('PricingPackages', params)
  }

  postActiveTrial(params) {
    return this.post('ActiveTrial', params)
  }

  postDeactiveTrial(params) {
    return this.post('DeactiveTrial', params)
  }

  getUserPricingPackagesPaged(params) {
    return this.get('UserPricingPackages_Paged', params)
  }

  getSampleQuotations(params) {
    return this.get(
      'SubscriptionAndPackage/SampleQuotations',
      params,
      'download',
    )
  }

  postQuotations(params) {
    return this.post(
      'SubscriptionAndPackage/Quotations',
      params,
      {},
      'download',
    )
  }

  getSampleContract(params) {
    return this.get(
      'SubscriptionAndPackage/Orders/SampleContract',
      params,
      'download',
    )
  }

  postRequest(params) {
    return this.post('SubscriptionAndPackage/Request', params)
  }

  getSubscriptionPricings(params) {
    return this.get('SubscriptionPricings', params)
  }

  postSubscriptionAndPackageOrders(params) {
    return this.post('SubscriptionAndPackage/Orders', params)
  }

  getSubscriptionAndPackageOrdersPaged(params) {
    return this.get('SubscriptionAndPackage/Orders/Paged', params)
  }

  getSubscriptionAndPackageOrdersTypes(params) {
    return this.get('SubscriptionAndPackage/Orders/Types', params)
  }

  postSubscriptionAndPackageNewTransaction(params) {
    return this.post('SubscriptionAndPackage/Orders/NewTransaction', params)
  }

  getSubscriptionAndPackageOrdersById(params) {
    return this.get('SubscriptionAndPackage/Orders/ById', params)
  }

  getDetailRequestContract(params) {
    return this.get(
      'SubscriptionAndPackage/Orders/Contract',
      params,
      'download',
    )
  }

  getDetailRequestConfirmation(params) {
    return this.get(
      'SubscriptionAndPackage/Orders/Confirmation',
      params,
      'download',
    )
  }

  getIsAvailableToAddNewSubscription(params) {
    return this.get(
      'SubscriptionAndPackage/IsAvailableToAddNewSubscription',
      params,
    )
  }

  getEngagementHistoryTypes(params) {
    return this.get('EngagementHistory/Types', params)
  }

  getEngagementHistoryPaged(params) {
    return this.get('EngagementHistory/Paged', params)
  }

  getUserProfileFields(params) {
    return this.get('UserProfileFields', params)
  }

  postCancelRequestOrder(params) {
    return this.post('SubscriptionAndPackage/Orders/Cancel', params)
  }

  getSNPNewTransactionPreview(params) {
    return this.get(
      'SubscriptionAndPackage/Orders/NewTransactionPreview',
      params,
    )
  }

  putUserSettingAlternative(params) {
    return this.put('UserSettingAlternative', params)
  }
}

export default new UserManagementProxy('UserManagement/')
